/**
 * @lodex-pro/web-billing — Account page (quick 260827-pwd).
 *
 * Voluntary password change for a signed-in billing user. Same reasoning as the
 * dispatch and admin surfaces: `updatePassword` requires the current password and
 * the caller already holds a valid session, so it grants no capability they lack.
 */

import type { JSX } from 'react';
import { ChangePassword } from '@lodex-pro/web-shared';

export function AccountPage(): JSX.Element {
  return (
    <div style={{ padding: '24px', maxWidth: '640px' }}>
      <h1 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '4px' }}>Account</h1>
      <p
        style={{
          fontSize: '13px',
          color: 'var(--color-text-secondary)',
          marginBottom: '16px',
        }}
      >
        Change the password you use to sign in.
      </p>
      <div className="auth-card-inline">
        <ChangePassword />
      </div>
    </div>
  );
}
